import { render } from "./ExtentionSection.vue?vue&type=template&id=d5eeb62c"
import script from "./ExtentionSection.vue?vue&type=script&lang=js"
export * from "./ExtentionSection.vue?vue&type=script&lang=js"

import "./ExtentionSection.vue?vue&type=style&index=0&id=d5eeb62c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__